import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { RevoLogo } from '../components/RevoLogo';
import { api } from '../utils/api';
import { toast } from 'sonner';
import { Eye, EyeOff, ShieldCheck, LogOut } from 'lucide-react';

const ForcePasswordChange = ({ user, onDone, onLogout }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) { toast.error('La password deve avere almeno 8 caratteri'); return; }
    if (newPassword !== confirmPassword) { toast.error('Le password non corrispondono'); return; }
    setLoading(true);
    try {
      await api.changePassword('', newPassword);
      toast.success('Password aggiornata! Benvenuto nel CRM.');
      onDone();
    } catch (err) {
      toast.error(err.message || 'Errore nel cambio password');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50/50 p-6" data-testid="force-password-change-page">
      <div className="w-full max-w-sm">
        <div className="mb-5 text-center">
          <div className="flex justify-center mb-2"><RevoLogo size="xl" /></div>
        </div>
        <Card data-testid="force-change-card">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-2 mb-1">
              <ShieldCheck className="w-5 h-5 text-primary" />
              <CardTitle>Imposta una nuova password</CardTitle>
            </div>
            <CardDescription>
              Per motivi di sicurezza, al primo accesso devi scegliere una password personale prima di usare il CRM.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="force-change-form">
              <div className="space-y-1.5">
                <Label htmlFor="new-password">Nuova Password</Label>
                <div className="relative">
                  <Input
                    id="new-password"
                    type={show ? 'text' : 'password'}
                    placeholder="Minimo 8 caratteri"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    data-testid="force-new-password-input"
                    className="pr-11"
                  />
                  <button type="button" onClick={() => setShow(!show)} tabIndex={-1}
                    className="absolute right-0 top-0 h-full px-3 flex items-center text-muted-foreground hover:text-foreground transition-colors duration-150">
                    {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="confirm-password">Conferma Password</Label>
                <Input
                  id="confirm-password"
                  type={show ? 'text' : 'password'}
                  placeholder="Ripeti la password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  data-testid="force-confirm-password-input"
                />
                {confirmPassword && newPassword !== confirmPassword && (
                  <p className="text-xs text-destructive">Le password non corrispondono</p>
                )}
              </div>
              <Button type="submit" className="w-full button-press" disabled={loading || newPassword.length < 8 || newPassword !== confirmPassword} data-testid="force-change-submit-button">
                {loading ? 'Salvataggio...' : 'Salva e continua'}
              </Button>
              <button type="button" onClick={onLogout} className="w-full text-xs text-muted-foreground hover:text-foreground flex items-center justify-center gap-1.5 pt-1" data-testid="force-change-logout">
                <LogOut className="w-3.5 h-3.5" /> Esci
              </button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
